import { normalizePhoneForMatch } from './phone.js';
import { normalizeWhatsappJid } from './whatsapp.js';

const normalizeText = (value) => {
  if (value === null || value === undefined) return '';
  const trimmed = String(value).trim();
  return trimmed || '';
};

export const normalizeContactIdentity = (value) => {
  const normalized = normalizeText(value);
  if (!normalized) return '';

  const jid = normalizeWhatsappJid(normalized);
  if (jid) return jid.toLowerCase();

  return normalizePhoneForMatch(normalized);
};

export const getContactIdentityVariants = (value) => {
  const normalized = normalizeText(value);
  if (!normalized) return [];

  const variants = new Set();
  const normalizedIdentity = normalizeContactIdentity(normalized);
  if (normalizedIdentity) {
    variants.add(normalizedIdentity);
  }

  const jid = normalizeWhatsappJid(normalized);
  if (jid) {
    const loweredJid = jid.toLowerCase();
    variants.add(loweredJid);

    const username = loweredJid.split('@', 1)[0];
    const digits = normalizePhoneForMatch(username);
    if (digits) {
      variants.add(digits);
    }
    return Array.from(variants);
  }

  const digits = normalizePhoneForMatch(normalized);
  if (digits) {
    variants.add(digits);
  }

  return Array.from(variants);
};

export const contactIdentitiesMatch = (left, right) => {
  const leftVariants = getContactIdentityVariants(left);
  const rightVariants = getContactIdentityVariants(right);

  if (leftVariants.length === 0 || rightVariants.length === 0) {
    return false;
  }

  const rightSet = new Set(rightVariants);
  return leftVariants.some((candidate) => rightSet.has(candidate));
};

export const pickContactIdentity = (entry) => {
  if (!entry || typeof entry !== 'object') return '';

  const candidates = [
    entry.whatsapp_jid,
    entry.whatsapp_lid,
    entry.whatsapp_number,
    entry.contact_phone,
    entry.phone_number,
    entry.phone,
    entry.jid,
    entry.remote_jid,
    entry.remoteJid,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeContactIdentity(candidate);
    if (normalized) return normalized;
  }

  return '';
};
